module.exports = "/static/assets/40c4ef8d5ee49892ab68d3040f4eee36.png";